var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-easy-lightbox',{ref:"lightbox",attrs:{"visible":_vm.open,"imgs":_vm.paths,"index":_vm.index},on:{"hide":_vm.hideHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }